import React, { useState } from "react";

import { IconPencil } from "@tabler/icons";
import {
  PageList,
  ENUM_FORM_DISPLAY,
  ENUM_FORM_LAYOUT_CONTAINER,
} from "../components/pageList";
import { useCellRender } from "../hooks/useCellRender";
import { useAuthUser } from "react-auth-kit";
import ActionCellRender from "../components/actionCellRender";
import RemoteSelect2 from "../components/remoteSelect2";
import { TextInput, Textarea } from "@mantine/core";
import MessageWindow from "../components/messageWindow";

const apiEntity = "ticket";

export default function Ticket({}) {
  const [cellRender] = useCellRender();
  const auth = useAuthUser();
  const [preQuery] = useState();

  const addFormSchema = {
    title: "New Ticket",
    description: "Please follow the step to create ticket",
    apiEntity,
    display: {
      mode: ENUM_FORM_DISPLAY.MODAL,
      size: "xl",
    },
    showSaveBar: true,
    closeAfterSave: true,
    initialValues: {
      subject: "",
      by: auth().id,
      author: auth(),
      members: [],
      type: "",
      itemCode: "",
    },
    layout: {
      containers: [
        {
          key: "main",
          parent: null,
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            variant: "pills",
            defaultValue: "Details",
            orientation: "vertical",
          },
        },
      ],
      fields: [
        {
          name: "type",
          component: RemoteSelect2,
          parent: "main",
          props: {
            label: "Ticket Type",
            apiEntity: "ticketType",
            valueField: "_id",
            labelField: "name",
            searchFields: ["name"],
            sort: {
              by: "name",
              order: "asc",
            },
          },
        },
        {
          name: "itemCode",
          component: TextInput,
          parent: "main",
          props: {
            label: "Code",
          },
        },
        {
          name: "subject",
          component: TextInput,
          parent: "main",
          props: {
            label: "Subject",
          },
        },
        {
          name: "description",
          component: Textarea,
          parent: "main",
          props: {
            label: "Description",
          },
        },
      ],
    },
  };

  const editFormSchema = {
    title: "Ticket",
    display: {
      mode: ENUM_FORM_DISPLAY.LINK,
    },
    apiEntity,
    layout: {
      containers: [
        {
          key: "section-message",
          parent: null,
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "",
            titleOrder: 5,
            withBorder: false,
            minHeight: 0,
            mt: 20,
            mb: 20,
          },
        },
      ],
      fields: [
        {
          name: "message",
          component: MessageWindow,
          parent: "section-message",
          props: {},
        },
      ],
    },
  };

  const formSchema = {
    add: addFormSchema,
    edit: editFormSchema,
  };

  const tableSchema = {
    showActionColumn: true,
    preQuery,
    select: ["code status subject type by "],
    columns: [
      {
        field: "code",
        headerName: "Code",
        sortable: true,
      },

      {
        field: "by",
        headerName: "By",
        sortable: true,
        cellRender: (col, data) => cellRender.User(data.by),
      },

      {
        field: "type",
        headerName: "Type",
        sortable: true,
        cellRender: (col, data) => data.type?.name,
      },

      {
        field: "itemCode",
        headerName: "Item",
        sortable: true,
        cellRender: (col, data) => data.entityId,
      },
      {
        field: "subject",
        headerName: "Subject",
        sortable: true,
      },
      {
        field: "status",
        headerName: "Status",
        sortable: true,
        cellRender: (col, data) => cellRender.Status(data.status),
      },

      {
        field: "action",
        cellRender: ActionCellRender,
        isAction: true,
        actions: [
          {
            name: "edit",
            icon: IconPencil,
            props: {},
          },
        ],
        actionMenu: [],
      },
    ],

    searchableFields: ["code", "status"],
  };

  return (
    <PageList
      title={"Tickets"}
      apiEntity={apiEntity}
      tableSchema={tableSchema}
      formSchema={formSchema}
      showImport={false}
      initSort={{ by: "updatedAt", order: "desc" }}
    />
  );
}
